<template>
    <div class='credit-card-inputs' :class='{ complete }'>
        <div class='stripe-element card-number' ref='cardNumberElement'></div>
        <div class='stripe-element card-expiry' ref='cardExpiryElement'></div>
        <div class='stripe-element card-cvc' ref='cardCvcElement'></div>
    </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'

export default {
    name: "Checkout",
    props: {
        stripeKey: {
            type: String,
            default: 'pk_test_XXXXXXXXXXXXXXXXXXXXXXXX'
        }
    },
    data () {
        return {
            complete: false,
            number: false,
            expiry: false,
            cvc: false,
            stripe: null,
            elements: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            options: {
                style: {
                    base: {
                        iconColor: '#c4f0ff',
                        color: '#000',
                        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                        fontSize: '16px',
                        fontSmoothing: 'antialiased',
                        ':-webkit-autofill': {
                            color: '#757575',
                        },
                        '::placeholder': {
                            color: '#757575',
                        },
                    },
                    invalid: {
                        iconColor: '#ff0000',
                        color: '#ff0000',
                    },
                }
            }
        }
    },
    async mounted() {
        // Load Stripe
        this.stripe = await loadStripe(this.stripeKey)
        this.elements = this.stripe.elements()

        // Create and mount card elements
        this.cardNumber = this.elements.create('cardNumber', this.options)
        this.cardExpiry = this.elements.create('cardExpiry', this.options)
        this.cardCvc = this.elements.create('cardCvc', this.options)

        this.cardNumber.mount(this.$refs.cardNumberElement)
        this.cardExpiry.mount(this.$refs.cardExpiryElement)
        this.cardCvc.mount(this.$refs.cardCvcElement)

        // Add event listeners
        this.cardNumber.on('change', (event) => {
            this.number = event.complete
            this.update()
        })
        this.cardExpiry.on('change', (event) => {
            this.expiry = event.complete
            this.update()
        })
        this.cardCvc.on('change', (event) => {
            this.cvc = event.complete
            this.update()
        })
    },
    beforeUnmount() {
        // Clean up elements
        if (this.cardNumber) this.cardNumber.destroy()
        if (this.cardExpiry) this.cardExpiry.destroy()
        if (this.cardCvc) this.cardCvc.destroy()
    },
    methods: {
        update () {
            this.complete = this.number && this.expiry && this.cvc

            // field completed, find field to focus next
            if (this.number) {
                if (!this.expiry) {
                    this.cardExpiry.focus()
                } else if (!this.cvc) {
                    this.cardCvc.focus()
                }
            } else if (this.expiry) {
                if (!this.cvc) {
                    this.cardCvc.focus()
                } else if (!this.number) {
                    this.cardNumber.focus()
                }
            }
        },
        // Expose method to create payment method
        async createPaymentMethod() {
            if (!this.stripe || !this.cardNumber) {
                throw new Error('Stripe not initialized')
            }
            return this.stripe.createPaymentMethod({
                type: 'card',
                card: this.cardNumber,
            })
        },
        // Expose method to create token (legacy support)
        async createToken() {
            if (!this.stripe || !this.cardNumber) {
                throw new Error('Stripe not initialized')
            }
            return this.stripe.createToken(this.cardNumber)
        }
    }
}
</script>

<style scoped>
.credit-card-inputs.complete {
    border: 2px solid green;
}

.stripe-element {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;
}
</style>
